export type Bonus = {
  number: string
  name: string
  headline: string
  items: string[]
  value: number
  color: string
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    name: 'Complete Stretching Exercise Library',
    headline: '180+ coach-ready exercises organized by body area, level and goal.',
    items: ['Beginner → Advanced', 'Hamstrings, Hips, Shoulders', 'Pike, Splits, Pancake, Bridge'],
    value: 17,
    color: '#3F6B4A',
  },
  {
    number: '02',
    name: 'Stretching Problem Solver',
    headline: "When an exercise isn't working, know exactly what to change.",
    items: ['Check position → Reduce range', 'Add support → Substitute', 'Retest'],
    value: 15,
    color: '#A07C22',
  },
  {
    number: '03',
    name: 'Express Class Builder',
    headline: '30 • 45 • 60-minute sessions without losing the class purpose.',
    items: ['Full, Lower + Upper Body', 'Hips + Hamstrings', 'Pike, Splits, Pancake, Bridge'],
    value: 12,
    color: '#2F5D7C',
  },
  {
    number: '04',
    name: 'Student Level & Progress System',
    headline: 'Assess. Place. Track. Progress.',
    items: ['Position quality + active control', 'Left / right differences', 'Beginner → Advanced levels'],
    value: 15,
    color: '#B8561A',
  },
  {
    number: '05',
    name: 'Professional Stretching Coach Toolkit',
    headline: 'Tools to deliver better, well-managed classes.',
    items: ['Coaching cue library', 'Mistake → correction', 'Mixed-level teaching'],
    value: 15,
    color: '#5B3F8C',
  },
]

export const pricing = {
  systemValue: 40,
  bonusValue: 74,
  totalValue: 114,
  price: 27,
  savings: 87,
}

export const systemStack = [
  '52 Weeks • 156 Ready-to-Teach Classes',
  'Beginner → Advanced',
  'Pike + Split Development',
  'Pancake + Bridge Development',
]

export const checkoutAssurances = ['Digital Access', 'One-Time Payment', '7-Day Guarantee', 'Secure Payment']
